export default __webpack_public_path__ + "static/media/CircularCheck.de18b7da.svg";